import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { showcaseApi } from '../api/showcaseApi';
import type {
  ApiError,
  KafkaPublishRequest,
  KafkaPublishResponse,
  KafkaReceivedResponse,
  KafkaStatusResponse,
} from '../types/showcase';

/**
 * GET /api/eraf/showcase/demo/kafka/status — C055 상태 조회
 * queryKey: ['common-showcase', 'kafka', 'status']
 */
export function useKafkaStatus() {
  return useQuery<KafkaStatusResponse, ApiError>({
    queryKey: ['common-showcase', 'kafka', 'status'],
    queryFn: () => showcaseApi.kafkaStatus(),
    staleTime: 15_000,
  });
}

/**
 * GET /api/eraf/showcase/demo/kafka/received?limit=20 — 수신 목록 조회
 * queryKey: ['common-showcase', 'kafka', 'received', limit]
 * enabled: false — publish 성공 후 자동 1회 폴링 + 수동 [재조회] 버튼으로 트리거
 */
export function useKafkaReceived(limit = 20) {
  return useQuery<KafkaReceivedResponse, ApiError>({
    queryKey: ['common-showcase', 'kafka', 'received', limit],
    queryFn: () => showcaseApi.kafkaReceived(limit),
    enabled: false,
  });
}

/**
 * POST /api/eraf/showcase/demo/kafka/publish — 메시지 발행
 * 성공 시 status 캐시 무효화 (receivedCount 등 갱신)
 */
export function useKafkaPublish() {
  const queryClient = useQueryClient();
  return useMutation<KafkaPublishResponse, ApiError, KafkaPublishRequest>({
    mutationFn: (req) => showcaseApi.kafkaPublish(req),
    mutationKey: ['common-showcase', 'kafka', 'publish'],
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['common-showcase', 'kafka', 'status'] });
    },
  });
}
